import _ from 'lodash';
import { API_GET_LIST_CLIENT_MY_PAGE_FAVORITES, API_GET_LIST_CLIENT_MY_PAGE_FAVORITES_MORE_SUCCESS, API_GET_LIST_CLIENT_MY_PAGE_FAVORITES_SUCCESS, API_GET_LIST_CLIENT_MY_PAGE_ORDERS, API_GET_LIST_CLIENT_MY_PAGE_ORDERS_SUCCESS, API_GET_LIST_CLIENT_MY_PAGE_RFPS, API_GET_LIST_CLIENT_MY_PAGE_RFPS_SUCCESS, API_UPDATE_CLIENT_MY_PAGE_CONSIDERATION_SUCCESS, API_UPDATE_CLIENT_MY_PAGE_ORDER_SUCCESS, API_UPDATE_CLIENT_MY_PAGE_REVIEW_SUCCESS, API_UPDATE_CLIENT_MY_PAGE_SEND_OFF_SUCCESS, } from '@/actions/ClientMyPageActions';
import { API_CREATE_FAVORITE, API_DELETE_FAVORITE, API_DELETE_FAVORITE_MANY, } from '@/actions/FavoriteActions';
import { API_CREATE_ONE_ORDER_SUCCESS } from '@/actions/OneSolutionActions';
import { deleteListItem, updateListItem } from '@/helpers/common';
const INITIAL_STATE = {
    favorites: [],
    hasMoreFavorites: false,
    orders: {},
    ordersTotal: 0,
    rfps: {},
    rfpsTotal: 0,
};
// TODO: TS化
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { meta, payload, total, type }) => {
    switch (type) {
        case API_DELETE_FAVORITE_MANY: {
            // お気に入り削除
            meta.ids.forEach((id) => deleteListItem(state.favorites, { id }));
            return Object.assign(Object.assign({}, state), { favorites: [...state.favorites] });
        }
        case API_CREATE_FAVORITE:
        case API_DELETE_FAVORITE:
        case API_GET_LIST_CLIENT_MY_PAGE_FAVORITES: {
            // お気に入り登録・お気に入り取得開始でデータをリセット
            return Object.assign(Object.assign({}, state), { favorites: [], hasMoreFavorites: false });
        }
        case API_GET_LIST_CLIENT_MY_PAGE_FAVORITES_SUCCESS: {
            // お気に入り取得
            return Object.assign(Object.assign({}, state), { favorites: payload.list, hasMoreFavorites: payload.list.length < total });
        }
        case API_GET_LIST_CLIENT_MY_PAGE_FAVORITES_MORE_SUCCESS: {
            // お気に入りをもっと取得
            return Object.assign(Object.assign({}, state), { favorites: [...state.favorites, ...payload.list], hasMoreFavorites: payload.list.length < total });
        }
        case API_CREATE_ONE_ORDER_SUCCESS: {
            // 申し込み回数の件数の更新
            return Object.assign(Object.assign({}, state), { hasMoreOrders: false, orders: [] });
        }
        case API_GET_LIST_CLIENT_MY_PAGE_RFPS: {
            // 公募
            return state;
        }
        case API_GET_LIST_CLIENT_MY_PAGE_RFPS_SUCCESS: {
            const { page } = meta.query;
            return Object.assign(Object.assign({}, state), { rfps: Object.assign(Object.assign({}, state.rfps), { [page]: payload.list }), rfpsTotal: total });
        }
        case API_GET_LIST_CLIENT_MY_PAGE_ORDERS: {
            // 申し込み
            return state;
        }
        case API_GET_LIST_CLIENT_MY_PAGE_ORDERS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { orders: Object.assign(Object.assign({}, state.orders), { [meta.page]: payload.list }), ordersTotal: total });
        }
        case API_UPDATE_CLIENT_MY_PAGE_CONSIDERATION_SUCCESS:
        case API_UPDATE_CLIENT_MY_PAGE_ORDER_SUCCESS:
        case API_UPDATE_CLIENT_MY_PAGE_SEND_OFF_SUCCESS:
        case API_UPDATE_CLIENT_MY_PAGE_REVIEW_SUCCESS: {
            // 再検討・受注・見送り・レビューの実施
            // 対象のリスト部分を取得する
            const newOrdersPairs = Object.keys(state.orders).map((orderKey) => {
                const items = state.orders[orderKey];
                return [orderKey, updateListItem(items, { id: payload.id }, payload)];
            });
            return Object.assign(Object.assign({}, state), { orders: _.fromPairs(newOrdersPairs) });
        }
        default: {
            return state;
        }
    }
};
